import { memo, useCallback, useMemo } from 'react';

import Button from '@/common/components/Button/Button';
import Heading from '@/common/components/Heading/Heading';
import { DEAD_ZONE_INSPECTOR_PAGE, SPECTRUM_PAGE } from '@/common/constants/pages';
import { navigateTo } from '@/common/helpers/navigateTo';
import URLBuilder from '@/common/network/URLBuilder';
import Storage from '@/common/services/Storage';
import { PENDING_TASK_PAGE_MAP } from '@/spectrum/constants/pendingTaskPage';
import { SpectrumQueryKey } from '@/spectrum/constants/query';
import { SpectrumProductModel } from '@/spectrum/entities/SpectrumProduct';

import styles from './SuccessTaskMessage.module.css';

interface SuccessTaskMessageProps {
  group: string;
  taskId: string;
  spectrumProduct: SpectrumProductModel;
}

function SuccessTaskMessage(props: SuccessTaskMessageProps) {
  const { group, taskId, spectrumProduct } = props;

  const page = PENDING_TASK_PAGE_MAP[group];

  const path = useMemo(() => {
    const params = {
      ...URLBuilder.params(),
      [SpectrumQueryKey.Product]: spectrumProduct.productId,
    };

    return `${page}${URLBuilder.buildQueryString(params)}`;
  }, [page, spectrumProduct]);

  const onNavigate = useCallback(() => {
    Storage.pullout(group, taskId, Storage.STORAGE_LOCAL);

    navigateTo(path);
  }, [path]);

  function renderTitle() {
    let title = '';

    switch (page) {
      case DEAD_ZONE_INSPECTOR_PAGE:
        title = 'Dead Zones Demo';

        break;
      case SPECTRUM_PAGE:
      default:
        title = 'Light-Spectrum Demo';

        break;
    }

    return title ? `${title} - ` : '';
  }

  return (
    <div>
      <Heading appearance="h4" className={styles.title}>
        <span>{renderTitle()}</span>

        <span>Conversion complete</span>
      </Heading>

      <div className={styles.description}>
        <span>Filename: </span>

        <span aria-label="Filename">{spectrumProduct.title}</span>
      </div>

      <Button color="accent" aria-label="View" onClick={onNavigate}>
        View
      </Button>
    </div>
  );
}

export default memo(SuccessTaskMessage);
